import React from 'react';
import { Bell, Globe, User } from 'lucide-react';

const TAB_LABELS = {
  fr: {
    overview: { title: "Vue d'ensemble", sub: "Aperçu de votre conférence et actions rapides" },
    registrations: { title: "Inscriptions", sub: "Gérer les demandes d'inscription à la conférence" },
    manageUsers: { title: "Utilisateurs", sub: "Gérer les comptes utilisateurs et leurs rôles" },
    invitations: { title: "Invitations visa", sub: "Approuver et envoyer les lettres d'invitation" },
    manageSpeakers: { title: "Conférenciers", sub: "Gérer la liste des conférencières et leur profil" },
    manageProgram: { title: "Programme", sub: "Organiser l'agenda de la conférence" },
    schedules: { title: "Horaires des participants", sub: "Voir les horaires personnalisés par participant" },
    documents: { title: "Documents", sub: "Télécharger et gérer les documents des participants" },
    resources: { title: "Ressources", sub: "Téléverser des ressources pour les participants" },
  },
  en: {
    overview: { title: "Overview", sub: "Snapshot of your conference and quick actions" },
    registrations: { title: "Registrations", sub: "Manage conference registration requests" },
    manageUsers: { title: "Users", sub: "Manage user accounts and roles" },
    invitations: { title: "Visa Invitations", sub: "Approve and send invitation letters" },
    manageSpeakers: { title: "Speakers", sub: "Manage the speakers roster and profiles" },
    manageProgram: { title: "Program", sub: "Organize the conference agenda" },
    schedules: { title: "Attendee Schedules", sub: "View personalized schedules by attendee" },
    documents: { title: "Documents", sub: "Upload and manage attendee documents" },
    resources: { title: "Resources", sub: "Upload resources for attendees" },
  },
};

export default function AdminTopBar({ activeTab, language, user, onLanguageToggle }) {
  const lang = language === 'en' ? 'en' : 'fr';
  const meta = (TAB_LABELS[lang] && TAB_LABELS[lang][activeTab]) || { title: activeTab, sub: '' };
  const initials = `${(user?.first_name || 'A')[0]}${(user?.last_name || '')[0] || ''}`.toUpperCase();
  return (
    <header
      data-testid="admin-topbar"
      className="h-16 border-b border-gray-200 bg-white/70 backdrop-blur sticky top-0 z-20 flex items-center px-6 gap-4"
    >
      <div className="flex-1 min-w-0">
        <h1 data-testid="admin-topbar-title" className="text-[17px] font-extrabold text-[#1D1D1D] leading-none truncate">{meta.title}</h1>
        <p className="text-[12px] text-gray-500 mt-1 truncate">{meta.sub}</p>
      </div>

      <button
        type="button"
        onClick={onLanguageToggle}
        data-testid="admin-topbar-lang"
        className="hidden sm:flex items-center gap-1.5 text-gray-500 hover:text-[#1D1D1D] text-[12px] font-semibold px-2.5 py-1.5 rounded-lg hover:bg-gray-100 transition"
      >
        <Globe className="w-3.5 h-3.5" />
        {lang === 'fr' ? 'FR' : 'EN'}
      </button>

      <button
        type="button"
        data-testid="admin-topbar-notifications"
        className="hidden sm:flex relative text-gray-500 hover:text-[#1D1D1D] p-2 rounded-lg hover:bg-gray-100 transition"
      >
        <Bell className="w-4 h-4" />
      </button>

      <div className="flex items-center gap-2.5 pl-3 border-l border-gray-200">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#1D1D1D] to-[#333] flex items-center justify-center text-white text-[11px] font-bold">
          {initials || <User className="w-3.5 h-3.5" />}
        </div>
        <div className="hidden md:block leading-tight">
          <p className="text-[12px] font-bold text-[#1D1D1D]">{user?.first_name || 'Admin'} {user?.last_name || ''}</p>
          <p className="text-[11px] text-gray-500">{user?.email || ''}</p>
        </div>
      </div>
    </header>
  );
}
